<template>
  <SwooshLayout>
    <div class="container">
      <div class="row rounded-3 shadow-lg px-2 py-4 bg-white fs-5 fw-semibold">
        <div class="col-md-4">
          <a class="d-flex flex-column justify-content-end position-relative overflow-hidden rounded-circle bg-size-cover
          bg-position-center flex-shrink-0 profile-avatar" data-bs-toggle="dropdown" aria-expanded="false"
          :style="{backgroundImage: `url(${user.profile_image_url ? user.profile_image_url : '/img/user.png'})`}">
            <span v-if="!showEditMenu && user.profile_image_url != null" class="d-block text-center avatar-pic pointer" @click="deleteImage()">
              <i class="fas fa-trash-can-xmark text-white"></i>
            </span>
            <span v-if="!showEditMenu && user.profile_image_url == null" class="d-block text-center avatar-pic pointer" @click="toggleShow">
              <i class="fas fa-camera text-white"></i>
            </span>
          </a>
          <span v-if="showEditMenu && userData.progress > 99" class="bg-light border border-success p-1 rounded-circle position-absolute" style="margin-top: 2.5rem; margin-left: -1.5rem;">
            <i class="fas fa-badge-check text-success" style="margin: 0 3px 0 4px; padding: 5px 2px 0 2px;"></i>
          </span>
          <div class="mt-2">
            <span class="px-4 fs-4">{{ user.first_name }} {{ user.last_name }}</span><br />
            <span v-if="userWorkinfo && userWorkinfo.job_title" class="px-4">{{ userWorkinfo.job_title }}</span>
            <span v-else class="px-4 text-secondary">{{ $t('job-title') }} - {{ $t('not-available') }}</span>
          </div>
          <my-upload
            v-if="show"
            v-model="show"
            field="img"
            :width="300"
            :height="300"
            :params="params"
            :headers="headers"
            img-format="jpg"
            :langType="'en'"
            @crop-success="cropSuccess"
          ></my-upload>
          <img :src="imgDataUrl" />
        </div>
        <div class="col-md-3 px-4 mt-3">
          <span v-if="user.name_suffix">{{ user.name_suffix }}</span>
          <span v-else class="text-secondary">{{ $t('network.auth.nameSuffix') }} - {{ $t('not-available') }}</span>
          <br />
          <span class="text-primary" style="cursor: pointer;" @click="showContactModal = !showContactModal">{{ $t('contact-info') }}</span>
        </div>
        <div class="col-md-3 px-4 mt-3">
          <span v-if="userWorkinfo && userWorkinfo.workplace"><i class="fa-solid fa-briefcase-blank"></i> {{ userWorkinfo.workplace }}</span>
          <span v-else class="text-secondary"><i class="fa-solid fa-briefcase-blank"></i> {{ $t('workplace') }} - {{ $t('not-available') }}</span>
          <br />
          <span>{{ $t('resume') }} - </span>
          <span v-if="userWorkinfo && userWorkinfo.cv_file" class="text-primary" style="cursor: pointer;" @click="downloadFile('Resume', userWorkinfo.cv_file_path)">
            {{ $t('network.download') }}
          </span>
          <span v-else class="text-secondary">{{ $t('not-available') }}</span>
        </div>
        <div class="col-md-2 text-end ps-0">
          <router-link v-if="!showEditMenu" :to="'/profile'" exact-active-class="active">
            <button id="view_profile" data-test="view_profile" class="btn btn-outline-primary" style="border: 2px solid; padding: 0.425rem 1.7rem !important">
              {{ $t('ModerationTab.view-profile') }}
            </button>
          </router-link>
          <router-link v-if="showEditMenu" :to="'/profile/edit'">
            <button id="edit_info" data-test="edit-info" class="btn btn-outline-primary" style="border: 2px solid; padding: 0.425rem 1.7rem !important">
              {{ $t('edit-info') }}
            </button>
          </router-link>
          <ProfileProgress v-if="!showEditMenu" />
        </div>
        <hr class="mt-2" style="opacity: 0.5; height: 2px;" />
        <div>
          <div>
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showContactModal" hide-footer hide-header size="md">
      <div class="text-secondary py-1">
        <h4 class="fw-bold">{{ $t('contact-info') }}</h4><hr />
        <div class="row">
          <div class="col-md-12 mb-3">
            <i class="fas fa-phone fs-2 me-3"></i>
            <span v-if="user.phone_number" class="fs-5" style="vertical-align: super;">{{ user.phone_number }}</span>
            <span v-else class="fs-5" style="vertical-align: super;">{{ $t('network.auth.phone') }} - {{ $t('not-available') }}</span>
          </div>
          <div class="col-md-12 mb-3">
            <i class="fas fa-envelope fs-2 me-3"></i>
            <span class="fs-5" style="vertical-align: super;">{{ user.email }}</span>
          </div>
          <div class="col-md-12 mb-3">
            <i class="fas fa-home fs-2 ms-n1 me-3"></i>
            <span v-if="user.address" class="fs-5" style="vertical-align: super;">{{ user.address }}</span>
            <span v-else class="fs-5" style="vertical-align: super;">{{ $t('network.auth.address') }} - {{ $t('not-available') }}</span>
          </div>
          <div class="col-md-12">
            <i class="fas fa-buildings fs-2 me-3"></i>
            <span v-if="userWorkinfo && userWorkinfo.workplace_address" class="fs-5" style="vertical-align: super;">{{ userWorkinfo.workplace_address }}</span>
            <span v-else class="fs-5" style="vertical-align: super;">{{ $t('ModerationTab.workplace-address') }} - {{ $t('not-available') }}</span>
          </div>
        </div>
      </div>
    </b-modal>
  </SwooshLayout>
</template>
<script>
const SwooshLayout = () => import('../layouts/swoosh/');
import ProfileProgress from '@/components/ProfileProgress.vue';
import split from 'lodash/split';
import myUpload from 'vue-image-crop-upload/upload-2.vue';
import { mapState } from 'vuex';

export default {
  components: {
    SwooshLayout,
    'my-upload': myUpload,
    ProfileProgress,
  },
  data() {
    return {
      showEditMenu: false,
      show: false,
      imgDataUrl: '',
      showContactModal: false,
    };
  },
  computed: {
    ...mapState('network', ['userData']),
    user() {
      return this.$store.getters['user'];
    },
    userWorkinfo() {
      return this.$store.getters['userWorkInfo'];
    },
  },
  watch: {
    '$route.fullPath': {
      handler(value) {
        let path = split(value, '/');
        if (path[2] && path[2].startsWith('edit')) {
          this.showEditMenu = false;
        } else {
          this.showEditMenu = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.$store.dispatch('fetchUserWorkInfo');
    this.$store.dispatch('fetchUserResearchCreds');
    this.$store.dispatch('network/loadUserData');
  },
  methods: {
    deleteImage() {
      let action = () => {
        this.$http.delete('auth/profile-image').then(() => {
          this.user.profile_image_url = null;
          this.$store.dispatch('resetUserInfo', this.user);
        });
      };
      this.showConfirmPrompt(action, this.$t('GeneralTab.are-you-sure-you-want-to-delete-your-picture'));
    },
    // crop and uploading profile image
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgDataUrl) {
      this.$http.post('auth/profile-image', { profile_image: imgDataUrl }).then(resp => {
        this.user.profile_image_url = resp.data.url;
        this.$store.dispatch('resetUserInfo', this.user);
      });
    },
    downloadFile(file_name, file) {
      var link = document.createElement('a');
      link.setAttribute('download', this.user.first_name+this.user.last_name+file_name);
      link.href = file;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
  },
};
</script>
<style>
.profile-avatar {
  width: 85px !important;
  height: 85px !important;
  background-size: 85px 85px !important;
  line-height: 110px !important;
  float: left !important;
  font-size: 35px !important;
}
.avatar-pic {
  background-color: rgba(0,0,0,.5);
  line-height: 5px !important;
  padding-bottom: 5px;
  padding-top: 3px;
}
.avatar-pic i {
  font-size: 15px !important;
}
</style>